import { Component, Input } from '@angular/core';
import Swal from 'sweetalert2';
import { GlobalConstants } from '../../global-constants';
import { QueryService } from '../../comun/services/query.service';
import { LoaderService } from '../../comun/services/loader.service';

@Component({
  selector: 'app-perfil-admin',
  templateUrl: './perfil-admin.component.html',
  styleUrl: './perfil-admin.component.css'
})
export class PerfilAdminComponent {
  @Input() misdatos!: any;
  @Input() perfil!: any;

  constructor(private query: QueryService, private loader: LoaderService) {}

  bloquearCuenta(userId: number) {
    Swal.fire({
      title: 'Confirmación',
      text: '¿Quieres bloquear esta cuenta? El usuario no podrá iniciar sesión ni usar la cuenta, pero sus datos se mantendrán guardados.',
      //icon: 'warning',
      imageUrl: GlobalConstants.urlServer + 'img/smilesad.png',
      imageWidth: 150,
      imageHeight: 150,
      showCancelButton: true,
      confirmButtonText: 'Sí',
      cancelButtonText: 'Cancelar',
      customClass: {
        confirmButton: 'custom-swal-confirm',
        /*cancelButton: 'custom-swal-cancel'*/
      },
    }).then((result) => {
      if (result.isConfirmed) {
        this.loader.show();
        this.query.query('misdatos', 'BLOQUEAR', { ID: userId }).subscribe((resultado:any) => {
          this.loader.hide();
          window.location.reload();
        });
      } else {
      }
    });
  }

  desbloquearCuenta(userId: number) {
    Swal.fire({
      title: 'Confirmación',
      text: '¿Quieres desbloquear esta cuenta? El usuario podrá iniciar sesión y usar la cuenta con normalidad.',
      //icon: 'warning',
      imageUrl: GlobalConstants.urlServer + 'img/smilehappy.png',
      imageWidth: 150,
      imageHeight: 150,
      showCancelButton: true,
      confirmButtonText: 'Sí',
      cancelButtonText: 'Cancelar',
      customClass: {
        confirmButton: 'custom-swal-confirm',
        /*cancelButton: 'custom-swal-cancel'*/
      },
    }).then((result) => {
      if (result.isConfirmed) {
        this.loader.show();
        this.query.query('misdatos', 'DESBLOQUEAR', { ID: userId }).subscribe((resultado:any) => {
          this.loader.hide();
          window.location.reload();
        });
      } else {
      }
    });
  }

  eliminarCuenta(userId: number) {
    Swal.fire({
      title: 'Confirmación',
      text: '¿Quieres eliminar tu cuenta? Esta acción no se puede deshacer.',
      //icon: 'warning',
      imageUrl: GlobalConstants.urlServer + 'img/smilesad.png',
      imageWidth: 150,
      imageHeight: 150,
      showCancelButton: true,
      confirmButtonText: 'Sí',
      cancelButtonText: 'Cancelar',
      customClass: {
        confirmButton: 'custom-swal-confirm',
        /*cancelButton: 'custom-swal-cancel'*/
      },
    }).then((result) => {
      if (result.isConfirmed) {
        this.loader.show();
        this.query.query('misdatos', 'BAJA', { ID: userId }).subscribe((resultado:any) => {
          this.loader.hide();
          window.location.href = GlobalConstants.urlServer + 'perfiles';
        });
      } else {
      }
    });
  }

}
